import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import { createPortal } from 'react-dom';
import DatePicker from 'react-datepicker';

const DatePickerEditor = forwardRef((props, ref) => {
  const [value, setValue] = useState(props.value && props.value.isValid() ? props.value : null);
  const prevValueRef = useRef(value);
  const pickerRef = useRef(null);

  useImperativeHandle(ref, () => ({
    getValue: () => value,
    isPopup: () => false,
    afterGuiAttached: () => {
      pickerRef.current.setFocus();
    },
  }));

  useEffect(() => {
    const prev = prevValueRef.current;
    const current = value;

    if ((prev && current && current.diff(prev) !== 0) || prev !== current) {
      props.stopEditing();
    }

    prevValueRef.current = current;
  }, [value]);

  const handleChange = date => {
    setValue(date);
  };

  return (
    <DatePicker
      ref={pickerRef}
      className="form-control input-sm"
      dropdownMode="select"
      onChange={handleChange}
      popperContainer={({ children }) => createPortal(children, document.body)}
      selected={value}
      showMonthDropdown
      showYearDropdown
    />
  );
});

export default DatePickerEditor;
